import React from "react";
import { Col, Row, Offcanvas } from "react-bootstrap";
import { ActionHandlerFunction, AdminApprovalGroup, UserProfile } from "@preveil-api";
import { AdminUIActionTypes } from "src/common";
import _ from "lodash";

type AllProps = {
  approval_group: AdminApprovalGroup;
  handleAction: ActionHandlerFunction;
};

/* Description: SidePanel component for when you click on an approval group row */
function SidePanelComponent(props: AllProps) {
  const { approval_group, handleAction } = props;

  // Description: handle hide modal.
  function handleHideModal() {
    handleAction({ actionType: AdminUIActionTypes.ShowSideNavMenu });
  }

  return (
    <Offcanvas
      show={true}
      onHide={handleHideModal}
      className="sidebar narrower-panel"
      placement="end"
      backdrop={false}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="semi-bold" as="h2">
          {approval_group.name}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="table-display">
          <Row className="header-card-row">
            <Col sm={5}>User</Col>
            <Col sm={6}>Role</Col>
          </Row>
          <div className="table-body">
            {_.map(approval_group.approvers, (approver: UserProfile, i: number) => {
              return (
                <Row key={i}>
                  <Col sm={5}>{approver.name}</Col>
                  <Col sm={6} className="with_cap">{approver.role}</Col>
                </Row>
              );
            })}
          </div>
        </div>
        <h4>Needed for approval: <b>{approval_group.required_approvers}</b></h4>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default React.memo(SidePanelComponent);
